import styles from "./OnboardingStyles.module.css"
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from "../../components/Button/BackButton/BackButton";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import Recommended from "./Recommended";
import Step1Form from "./Step1Form";
import Step2Form from "./Step2Form";
import Step3Form from "./Step3Form";
import Step4Form from "./Step4Form";
import Step5Form from "./Step5Form";
import Step6Form from "./Step6Form";
import Step7Form from "./Step7Form";
import Step8Form from "./Step8Form";
import Step9Form from "./Step9Form";
import MarikaCropped from '../../assets/images/MarikaCropped.png';
import { useWindowSize } from "../../hooks/useWindowSize";
import { useOnboardingData } from "../../hooks/useOnboardingData";
import { useTranslation } from "react-i18next";
import { useOrderContext } from "../../context/OrderContext";
/**
* Props for the OnboardingForm component.
*/ 
interface OnboardingProps {
    className? : string, // Optional additional class
    onBack?: ()=>void, // Go back event handler
    popup?: boolean // Optional flag - whether onboarding is in form of popup
}
/**
* An onboarding component with optional styling and navigation.
* Contains all the onboarding steps and the logic
*
* @param props Onboarding props
* @param {string} props.className - Optional additional class
* @param {() => void} props.onBack - Go back event handler
* @returns TSX.Element
*/
const OnboardingForm = ({className, onBack, popup = false}: OnboardingProps) => {
    const { t } = useTranslation(); // Translation
    const windowSize = useWindowSize(); // Window size
    const navigate = useNavigate(); // Navigate
    const [step, setStep] = useState(1) // Current setup step
    const stepNumber = 9 // Number of steps
    const {formData, setFormData, clearData} = useOnboardingData(); // Onboarding data
    const {orderData} = useOrderContext();

    // Handle steps of onboarding
    const handleStepBack = () => {
        if (step < 2 ) {
            // Cleanup
            clearData();
            if(onBack){
                onBack()
            }else{
                navigate("/order-settings"); 
            }
        }else{
            setStep(step-1)
        }
    }
    useEffect(()=>{
        setFormData((prev: typeof formData) => ({ ...prev, note: orderData.note ?? "" }))
    },[])

    // Step logic
    const stepComponents = {
        1: Step1Form,
        2: Step2Form,
        3: Step3Form,
        4: Step4Form,
        5: Step5Form,
        6: Step6Form,
        7: Step7Form,
        8: Step8Form,
        9: Step9Form,
    };
    const StepComponent = stepComponents[step as keyof typeof stepComponents];

    return(
        <>
            <div className={`${styles.OnboardingForm} ${className ? className : ""}`}>
                {step <= stepNumber ? (
                    <>
                        <div className={styles.OnboardingHeader}>
                            <BackButton text={t("buttons.back")} onClick={() => handleStepBack()} />
                            {windowSize > 900 && (
                                <ProgressBar currentStep={step} stepNumber={stepNumber} />
                            )}
                        </div>
                        {StepComponent && <StepComponent currentStep={step} setStep={setStep} formData={formData} setFormData={setFormData} onPopup={popup}/>}
                        
                        {windowSize > 900 && step != 9 && (
                            <div className={styles.Avatar}>
                                <img className={styles.Logo} src={MarikaCropped} alt="Avatar Marika" />
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div className={styles.OnboardingHeader}>
                            <BackButton text={t("buttons.back")} onClick={() => handleStepBack()} />
                        </div>
                        <Recommended currentStep={step} setStep={setStep}  onEnd={onBack} formData={formData} setFormData={setFormData} clearData={clearData} popup={popup}/>
                    </>
                )}
            </div>
        </>
    )
};

export default OnboardingForm;